import { render, staticRenderFns } from "./ItemFormError.vue?vue&type=template&id=7196b315&"
import script from "./ItemFormError.vue?vue&type=script&lang=js&"
export * from "./ItemFormError.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports